<template>
  <div class="hilo-stage">
    <div class="hilo-stage_header">
      <div class="hilo-stage_header--title" @click="isToggled = !isToggled">
        <img src="/static/img/chevron-down.svg" alt="" />
        <h2>Stage {{ index + 1 }} - {{ stage.name }}</h2>
      </div>
      <div v-if="!isStudent" class="hilo-stage_header--actions">
        <button type="button" @click="$emit('duplicate-stage', stage.id)">
          Duplicate
        </button>
        <div class="hilo-stage_header--actions-divider"></div>
        <button type="button" @click="confirmDelete('stage', stage.id)">
          Delete
        </button>
      </div>
    </div>

    <div class="hilo-stage_table" v-if="isToggled">
      <div
        class="hilo-stage_table--header"
        :style="{
          backgroundColor: stage.color,
          gridTemplateColumns: `repeat(${isStudent ? '40' : '38'}, minmax(35px, 1fr))`,
        }"
      >
        <div class="hilo-stage_table--header-column" />
        <div class="hilo-stage_table--header-column">Title</div>
        <div class="hilo-stage_table--header-column">Type</div>
        <div class="hilo-stage_table--header-column">Day</div>
        <div class="hilo-stage_table--header-column">Num</div>
        <div class="hilo-stage_table--header-column">Time</div>
        <div v-if="isStudent" class="hilo-stage_table--header-column">
          Status
        </div>
      </div>

      <div
        v-for="(lesson, j) in stage.lessons"
        :key="j"
        class="hilo-stage_table--rows"
      >
        <div
          class="hilo-stage_table--rows-row hilo-stage_table--rows-header"
          :style="{
            gridTemplateColumns: `repeat(${isStudent ? '40' : '38'}, minmax(35px, 1fr))`,
          }"
        >
          <div class="hilo-stage_table--rows-header-column justify-center">
            <button v-if="!isStudent" type="button" @click="togglePopup(j)">
              <img src="/static/img/dotted.svg" alt="" />
            </button>
            <div v-if="showPopup === j" class="popup-container">
              <div class="popup">
                <button @click="confirmDelete('lesson', lesson.id)">
                  <i class="el-icon-delete"></i>
                </button>
                <button @click="editLesson(lesson.id)">
                  <i class="el-icon-edit"></i>
                </button>
              </div>
            </div>
          </div>
          <div
            class="hilo-stage_table--rows-header-column"
            @click="toggleLesson(j)"
          >
            <span>{{ lesson.name }}</span>
            <img src="/static/img/chevron-up.svg" alt="" />
          </div>
          <div class="hilo-stage_table--rows-header-column">
            <span>{{ lesson.lessonType.name }}</span>
          </div>
          <div class="hilo-stage_table--rows-header-column">
            <span>{{
              stage.lessons.indexOf(lesson) + 1 + previousLength
            }}</span>
          </div>
          <div class="hilo-stage_table--rows-header-column">
            <span>{{ index + 1 }}-{{ stage.lessons.indexOf(lesson) + 1 }}</span>
          </div>
          <div class="hilo-stage_table--rows-header-column">
            <span>{{ lesson.time + lesson.debrief }}</span>
          </div>
          <div v-if="isStudent" class="hilo-stage_table--rows-header-column">
            <img
              v-if="isLessonCompleted(lesson.id)"
              src="/static/img/solid-checkmark.svg"
              alt=""
            />
            <img
              v-else-if="isLessonLate(lesson.id)"
              src="/static/img/WarningIcon.svg"
              alt=""
            />
          </div>
        </div>
        <template v-if="activeLessons.includes(j)">
          <div
            v-for="(assignment, a) in getAssignmentByLesson(lesson.id)"
            :key="a"
            class="hilo-stage_table--rows-row"
          >
            <div class="hilo-stage_table--rows-row-cell" />
            <div class="hilo-stage_table--rows-row-cell justify-center">
              <img
                v-if="isStudent && isAssignmentDone(assignment)"
                src="/static/img/solid-checkmark.svg"
                alt=""
              />
              <img
                v-else-if="
                  isStudent &&
                  typeof assignment.dueDate === 'string' &&
                  assignment.dueDate.includes('Past') &&
                  assignment.graded
                "
                src="/static/img/WarningIcon.svg"
                alt=""
              />
            </div>
            <div class="hilo-stage_table--rows-row-cell">
              {{ assignment.name }}
            </div>
            <div class="hilo-stage_table--rows-row-cell">
              <div class="assignment-attachments">
                {{ assignment.description }}
                <button type="button" @click="goToPage(assignment)">
                  <img src="/static/img/attachment.svg" alt="" />
                </button>
              </div>
              <span v-if="isStudent">{{ assignment.dueDate }}</span>
            </div>
          </div>
          <div v-if="!isStudent" class="hilo-stage_table--rows-add-assignment">
            <div class="hilo-stage_table--rows-add-assignment-cell" />
            <div class="hilo-stage_table--rows-add-assignment-cell" />
            <div
              class="hilo-stage_table--rows-add-assignment-cell"
              @click="$emit('create-assignment', lesson.id)"
            >
              <img src="/static/img/plus.svg" alt="" />
              Add Assignment
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="!isStudent"
        class="hilo-stage_table--rows hilo-stage_table--rows-add-row"
      >
        <div class="hilo-stage_table--rows-add-row-cell" />
        <div
          class="hilo-stage_table--rows-add-row-cell"
          @click="$emit('create-lesson', stage.id)"
        >
          <img src="/static/img/plus.svg" alt="" />
          Add Lesson
        </div>
      </div>
    </div>
    <BaseModal
      v-if="confirmModal"
      :is-visible="true"
      title="Delete Confirmation"
      @close="confirmModal = false"
    >
      <template v-slot:default>
        <div class="actions">
          <button @click="confirmModal = false">Cancel</button>
          <button @click="handleDeleteConfirmation">Confirm</button>
        </div>
      </template>
    </BaseModal>
    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import dayjs from "dayjs";
import BaseModal from "../../../Components/BaseModal.vue";
import { AssignmentsAPIService } from "@/servicehandlers/AssignmentsAPIService.js";
import { useLoginStore } from "@/stores/loginStore";
import ClassesAPIService from "../../../../../servicehandlers/ClassesAPIService";
import UsersAPIService from "../../../../../servicehandlers/UsersAPIService";
import ToastNotifier from "../../../../../components/ToastNotifier.vue";

const assignmentsAPI = new AssignmentsAPIService();
const classesAPIService = new ClassesAPIService();
const userAPIService = new UsersAPIService();

export default {
  props: {
    index: Number,
    stage: {
      type: Object,
      default: () => {},
    },
    assignments: {
      type: Array,
      default: () => [],
    },
    tableHeaderColumns: {
      type: Array,
      default: () => ["Title", "Type", "Day", "Num.", "Time"],
    },
    previousLength: Number,
    isStudent: Boolean,
  },
  components: {
    BaseModal,
    ToastNotifier,
  },
  data() {
    return {
      confirmModal: false,
      isToggled: true,
      activeLessons: [],
      showPopup: null,
      studentAssignments: [],
      student: null,
      classObj: null,
      hideTaking: false,
    };
  },
  computed: {
    gridColumns() {
      const baseColumns = 38;
      const additionalColumns =
        Math.max(0, this.tableHeaderColumns.length - 5) * 2;
      return baseColumns + additionalColumns;
    },
    assignmentsByStudentId() {
      return this.studentAssignments
        .filter((assignment) => assignment.userId === this.student.id)
        .map((assignment) => assignment.assignmentId);
    },
    isLessonCompleted() {
      return (lessonId) => {
        const assignments = this.getAssignmentByLesson(lessonId);
        return assignments.every((assignment) =>
          this.isAssignmentDone(assignment),
        );
      };
    },
    isLessonLate() {
      return (lessonId) => {
        const assignments = this.getAssignmentByLesson(lessonId);
        return assignments.some(
          (assignment) =>
            typeof assignment.dueDate === "string" &&
            assignment.dueDate.includes("Past") &&
            assignment.graded,
        );
      };
    },
  },
  watch: {
    "$route.query.studentId": {
      immediate: true,
      handler() {
        this.start();
      },
    },
    "$route.query.curriculumId": {
      immediate: true,
      handler() {
        this.start();
      },
    },
  },
  methods: {
    async start() {
      this.student = useLoginStore().getUser;
      if (this.student.userType.name !== "Student") {
        this.hideTaking = true;
        await this.getStudent();
      }
      if (this.student) {
        await this.getAllAssignments();
      }
      if (this.isStudent) {
        await this.getClassForStudent();
        await this.calculateDueDates();
      }
    },
    getStudent() {
      if (this.$route.query.studentId) {
        return userAPIService
          .getById(this.$route.query.studentId)
          .then((response) => {
            this.student = response;
          });
      } else {
        if (this.isStudent) {
          this.$refs.toast.showError("Unknown student");
        }
      }
    },
    isAssignmentDone(assignment) {
      if (
        !assignment.graded &&
        typeof assignment.dueDate === "string" &&
        assignment.dueDate.includes("Past")
      )
        return true;
      return this.assignmentsByStudentId.includes(assignment.id);
    },
    async getAllAssignments() {
      this.studentAssignments = await assignmentsAPI.getAllStudentAssignments();
    },
    confirmDelete(type, id) {
      this.deleteType = type;
      this.id = id;
      this.confirmModal = true;
    },
    handleDeleteConfirmation() {
      this.$emit("delete-confirmed", {
        type: this.deleteType,
        id: this.id,
      });
      this.confirmModal = false;
    },
    editLesson(lessonId) {
      this.$router.push({
        name: "Create Lesson",
        query: {
          type: "edit",
          lessonId: lessonId,
          curriculumId: this.stage.curriculumId,
        },
      });
    },
    toggleLesson(index) {
      const lessonIndex = this.activeLessons.indexOf(index);
      if (lessonIndex !== -1) {
        this.activeLessons.splice(lessonIndex, 1);
      } else {
        this.activeLessons.push(index);
      }
    },
    getAssignmentByLesson(lessonId) {
      return this.assignments.filter(
        (assignment) => assignment.lessonId === lessonId,
      );
    },
    getClassForStudent() {
      return classesAPIService
        .getByStudentId(this.student.id)
        .then((response) => {
          this.classObj = response.class;
        });
    },
    async calculateDueDates() {
      for (let lesson of this.stage.lessons) {
        for (let assignment of this.assignments.filter(
          (data) => data.lessonId === lesson.id,
        )) {
          assignment.dueDate = "";
          let count =
            this.stage.lessons.indexOf(lesson) + 1 + this.previousLength;
          if (!this.classObj) {
            await this.getClassForStudent();
          }

          let selectedDays = [];
          if (this.classObj.onSunday) {
            selectedDays.push("Sunday");
          }
          if (this.classObj.onMonday) {
            selectedDays.push("Monday");
          }
          if (this.classObj.onTuesday) {
            selectedDays.push("Tuesday");
          }
          if (this.classObj.onWednesday) {
            selectedDays.push("Wednesday");
          }
          if (this.classObj.onThursday) {
            selectedDays.push("Thursday");
          }
          if (this.classObj.onFriday) {
            selectedDays.push("Friday");
          }
          if (this.classObj.onSaturday) {
            selectedDays.push("Saturday");
          }

          let dueDate = dayjs(this.classObj.startDate);

          do {
            if (selectedDays.includes(dueDate.format("dddd"))) {
              count--;
            }
            dueDate = dueDate.add(1, "day");
          } while (count > 0);

          dueDate = dueDate.add(-1, "day");

          let today = dayjs();

          if (today.isAfter(dueDate, "day")) {
            assignment.dueDate = "Past Due: " + dueDate.format("MM/DD/YYYY");
          } else if (today.isSame(dueDate, "day")) {
            assignment.dueDate = "Due: Today";
          } else if (dueDate.isSame(today.add(1, "day"), "day")) {
            assignment.dueDate = "Due: Tomorrow";
          } else if (dueDate.isAfter(today.add(7, "days"), "day")) {
            assignment.dueDate = "Due: " + dueDate.format("MM/DD/YYYY");
          } else {
            assignment.dueDate = "Due: " + dueDate.format("dddd");
          }
        }
      }
      this.$forceUpdate();
    },
    goToPage(assignment) {
      if (this.isStudent) {
        if (this.hideTaking) {
          if (this.isAssignmentDone(assignment)) {
            this.$router.push({
              name: "Graded Assignment",
              query: {
                assignmentId: assignment.id,
                studentId: this.$route.query.studentId,
              },
            });
          } else {
            this.$refs.toast.showInfo("Student hasn't completed assignment");
          }
        } else {
          this.$router.push({
            name: this.isAssignmentDone(assignment)
              ? "Graded Assignment"
              : "Take Assignment",
            query: {
              assignmentId: assignment.id,
            },
          });
        }
      } else {
        this.$router.push({
          name: "Create Assignment",
          query: {
            type: "edit",
            assignmentId: assignment.id,
          },
        });
      }
    },
    togglePopup(index) {
      this.showPopup = this.showPopup === index ? null : index;
    },
    closePopup() {
      this.showPopup = null;
    },
  },
  async mounted() {
    await this.start();
  },
};
</script>
<style scoped lang="scss">
.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.popup-container {
  position: absolute;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
  background: #fff;
  z-index: 2;
  border-radius: 3px;
  padding: 12px;

  .popup {
    display: flex;
    gap: 12px;
    background: #fff;
    border-radius: 3px;

    i {
      color: #272727;
    }

    button {
      border-radius: 0;

      &:not(:last-child) {
        border-right: 1px solid #bfbfbf;
        padding-right: 12px;
      }
    }
  }
}

.hilo-stage {
  min-width: 1000px;
  display: grid;
  gap: 15px;

  &_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    &--title {
      display: flex;
      gap: 10px;
      align-items: center;
      cursor: pointer;

      h2 {
        overflow: hidden;
        color: #404040;
        text-overflow: ellipsis;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 25px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 0;
      }
    }

    &--actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;

      button {
        color: #404040;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        background: none;
        border-radius: 0;
        padding: 0;
        width: 100%;
      }

      &-divider {
        height: 15px;
        width: 2px;
        background: rgba(64, 64, 64, 0.25);
        transform: translateY(1px);
      }
    }
  }

  &_table {
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);

    &--header {
      display: grid;
      background: #a148ad;
      border-radius: 10px 10px 0 0;
      grid-template-columns: repeat(38, minmax(35px, 1fr));

      &-column {
        color: #fff;
        text-overflow: ellipsis;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 10px;
        position: relative;

        &:nth-child(2) {
          grid-column: span 28 / span 28;
        }

        &:nth-child(3) {
          grid-column: span 3 / span 3;
        }

        &:not(:nth-child(-n + 3)) {
          grid-column: span 2 / span 2;
        }
      }
    }

    &--rows {
      &:last-child {
        .hilo-stage_table--rows-add-row-cell {
          &:first-child {
            border-radius: 0 0 0 10px;
          }

          &:last-child {
            border-radius: 0 0 10px 0;
          }
        }

        .hilo-stage_table--rows-row {
          &:last-child {
            div {
              &:first-child {
                border-radius: 0 0 0 10px;
              }
              &:last-child {
                border-radius: 0 0 10px 0;
              }
            }
          }
        }
      }

      &-header {
        display: grid;
        grid-template-columns: repeat(38, minmax(35px, 1fr));

        &-column {
          color: #404040;
          font-family: Helvetica, Arial, sans-serif;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          padding: 10px;
          position: relative;

          border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
          border-left: 0.5px solid rgba(64, 64, 64, 0.5);

          &:nth-child(2) {
            grid-column: span 28 / span 28;
            cursor: pointer;
            display: flex;
            gap: 10px;
            align-items: center;

            img {
              transform: rotate(180deg);
              transition: transform 0.3s ease;
            }

            &.active {
              img {
                transform: rotate(0);
              }
            }
          }

          &:nth-child(3) {
            grid-column: span 3 / span 3;
          }

          &:not(:nth-child(-n + 3)) {
            grid-column: span 2 / span 2;
          }

          &:last-child {
            border-right: 0.25px solid rgba(64, 64, 64, 0.5);
          }

          button {
            background: none;
            padding: 0;
            width: 100%;
          }
        }
      }

      &-row {
        display: grid;
        grid-template-columns: repeat(38, minmax(35px, 1fr));

        &-cell {
          color: #404040;
          font-family: Helvetica, Arial, sans-serif;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;

          &.justify-center {
            justify-content: center;
          }

          border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
          border-left: 0.5px solid rgba(64, 64, 64, 0.5);

          &:nth-child(3) {
            grid-column: span 5 / span 5;
          }

          &:last-child {
            grid-column: span 31 / span 31;
            border-right: 0.25px solid rgba(64, 64, 64, 0.5);
          }

          span {
            color: rgba(64, 64, 64, 0.5);
            font-family: Helvetica, Arial, sans-serif;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }

          .assignment-attachments {
            display: flex;
            gap: 10px;
            align-items: center;

            button {
              background: none;
              padding: 0;
            }
          }
        }
      }

      &-add-assignment {
        display: grid;
        grid-template-columns: repeat(38, minmax(35px, 1fr));

        &-cell {
          padding: 10px;
          display: flex;
          gap: 10px;
          align-items: center;
          border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
          border-left: 0.5px solid rgba(64, 64, 64, 0.5);
          color: rgba(64, 64, 64, 0.5);
          font-family: Helvetica, Arial, sans-serif;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          &:nth-child(3) {
            grid-column: span 36 / span 36;
            cursor: pointer;
          }

          &:last-child {
            border-right: 0.25px solid rgba(64, 64, 64, 0.5);
          }
        }
      }

      &-add-row {
        display: grid;
        grid-template-columns: repeat(38, minmax(35px, 1fr));

        &-cell {
          color: rgba(64, 64, 64, 0.5);
          font-family: Helvetica, Arial, sans-serif;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          padding: 10px;

          border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
          border-left: 0.5px solid rgba(64, 64, 64, 0.5);

          &:last-child {
            display: flex;
            align-items: center;
            gap: 10px;
            border-right: 0.25px solid rgba(64, 64, 64, 0.5);
            grid-column: span 37 / span 37;
            cursor: pointer;
          }
        }
      }

      &:last-child {
        .course-stages_table--rows-add-row {
          &-cell {
            &:first-child {
              border-radius: 0 0 0 10px;
            }

            &:last-child {
              border-radius: 0 0 10px 0;
            }
          }
        }
      }
    }
  }
}
</style>
